import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutomaticIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.45833 10.7082C1.45833 10.3861 1.7195 10.1249 2.04166 10.1249H5.25C5.57216 10.1249 5.83333 10.3861 5.83333 10.7082C5.83333 11.0304 5.57216 11.2916 5.25 11.2916H2.04166C1.7195 11.2916 1.45833 11.0304 1.45833 10.7082Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.583328 7.49989C0.583328 7.17772 0.844495 6.91655 1.16666 6.91655H3.79166C4.11383 6.91655 4.375 7.17772 4.375 7.49989C4.375 7.82205 4.11383 8.08322 3.79166 8.08322H1.16666C0.844495 8.08322 0.583328 7.82205 0.583328 7.49989Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.74999 4.29155C1.74999 3.96939 2.01116 3.70822 2.33333 3.70822H5.25C5.57216 3.70822 5.83333 3.96939 5.83333 4.29155C5.83333 4.61372 5.57216 4.87489 5.25 4.87489H2.33333C2.01116 4.87489 1.74999 4.61372 1.74999 4.29155Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1311 1.70739C10.3802 1.80587 10.5303 2.06141 10.4949 2.32698L9.9996 6.04155H12.2182C12.2249 6.04155 12.2316 6.04155 12.2383 6.04155C12.3671 6.04152 12.5005 6.04149 12.6108 6.05157C12.7192 6.06149 12.9165 6.08776 13.0928 6.22387C13.2985 6.3826 13.423 6.62451 13.4326 6.88413C13.4409 7.10675 13.3476 7.28256 13.2926 7.37657C13.2368 7.47213 13.1592 7.58071 13.0843 7.68547C13.0804 7.69095 13.0765 7.69641 13.0726 7.70185L9.22467 13.0889C9.06895 13.307 8.78474 13.3909 8.53558 13.2924C8.28641 13.1939 8.13637 12.9384 8.17178 12.6728L8.66706 8.95822H6.44848C6.44179 8.95822 6.43508 8.95822 6.42836 8.95822C6.2996 8.95825 6.16613 8.95828 6.05589 8.9482C5.94745 8.93829 5.75016 8.91201 5.57381 8.7759C5.36815 8.61717 5.24365 8.37526 5.23403 8.11564C5.22577 7.89303 5.31906 7.71722 5.37403 7.62321C5.4299 7.52764 5.5075 7.41906 5.58236 7.3143C5.58627 7.30883 5.59017 7.30337 5.59406 7.29792L9.44198 1.91083C9.59771 1.69282 9.88192 1.60891 10.1311 1.70739Z",
			fill: "currentColor"
		})
	]
});
export default SvgAutomaticIcon;
